import { type HeaderGroup } from '@tanstack/react-table'

import { type KeyValue } from '@ui/interfaces'
import clsx from 'clsx'

interface HeadersProps {
  headers: HeaderGroup<KeyValue>[]
  dataSource: 'logs' | 'spans' | 'metrics' | string
}

export const DBLHeaders = ({ headers, dataSource }: HeadersProps) => {
  return (
    <div className="sticky top-0 z-10 m-0 bg-white">
      {headers.map((headerGroup) => (
        <div key={`${dataSource}-${headerGroup.id}`} className="flex w-full flex-row">
          {headerGroup.headers.map((header) => {
            // console.log(flexRender(header.column.columnDef.header, header.getContext()))
            return (
              <div
                key={`${dataSource}-${header.id}`}
                data-testid={`header-${header.id}`}
                className="relative z-10 snap-end truncate px-4 py-2.5 text-left text-sm font-semibold text-gray-900"
                style={{ width: header.getSize() }}>
                {/* {flexRender(header.column.columnDef.header, header.getContext())} */}
                <p className="text-sm font-medium">{header.id === 'expander' ? '' : header.id}</p>
                <div
                  onMouseDown={header.getResizeHandler()}
                  className={clsx(
                    'absolute right-0 top-0 z-10 h-full w-2.5 cursor-col-resize bg-primary-300 transition-colors duration-200 hover:bg-primary-400',
                    {
                      'bg-primary-400': !header.column.getIsResizing(),
                      'bg-primary-300': header.column.getIsResizing(),
                    }
                  )}
                />
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}
